import React from 'react';
import { IOType } from 'shared/src/api/io-types';
import { FileInvoice } from '@/icons/file-invoice';
import { ArrowsCircle } from '@/icons/arrows-circle';
import { FilePlus } from '@/icons/file-plus';

type IoTypeBadgeProps = {
  ioType: IOType;
  ioNumber: string | null;
};

export function IoTypeBadge({ ioType, ioNumber }: IoTypeBadgeProps) {
  return (
    <div className={`flex items-center gap-1 rounded p-1 text-xs text-white ${bgColor(ioType)}`}>
      {icon(ioType)}
      <span className="font-medium">{label(ioType)}</span>
      {ioNumber && <span className="font-bold">{ioNumber}</span>}
    </div>
  );
}

function label(ioType: IOType): string {
  switch (ioType) {
    case 'io':
      return 'IO';
    case 'revision':
      return 'Revision';
    case 'extension':
      return 'Extension';
  }
}

function bgColor(ioType: IOType): string {
  switch (ioType) {
    case 'io':
      return 'bg-gray-600';
    case 'revision':
      return 'bg-yellow-600';
    case 'extension':
      return 'bg-blue-600';
  }
}

function icon(ioType: IOType): React.ReactNode {
  switch (ioType) {
    case 'io':
      return <FileInvoice fill="white" />;
    case 'revision':
      return <ArrowsCircle fill="white" />;
    case 'extension':
      return <FilePlus fill="white" />;
  }
}
